module.exports = __webpack_public_path__ + "media/application/images/svgs/upload-cloud-2c1dcf4357f259d4bbb7ce26a659ccd1.svg";